import { WattiActionTypes } from "./constants";

const INIT_STATE = {
  templates: [],
  loading: false,
  error: null,
};

const WattiReducer = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case WattiActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case WattiActionTypes.GET_WATTI_TEMPLATES:
          return {
            ...state,
            templates: action.payload.data,
            loading: false,
            error: null,
          };
        case WattiActionTypes.SEND_WATTI_BROADCAST:
          return {
            ...state,
            loading: false,
            error: null,
          };
        default:
          return state;
      }

    case WattiActionTypes.API_RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case WattiActionTypes.GET_WATTI_TEMPLATES:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case WattiActionTypes.SEND_WATTI_BROADCAST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    default:
      return state;
  }
};

export default WattiReducer;
